import { load } from "scrivito"
import {
  BuildingReferenceObj,
  BuildingReferenceObjClass
} from "scrivito/Objs/BuildingReference/BuildingReferenceObjClass"
import { BuildingType } from "shared/types/references/BuildingType"

export async function fetchBuildingReferencesByBuildingTypes(
  buildingTypes: BuildingType[]
): Promise<BuildingReferenceObj[]> {
  return load(() =>
    BuildingReferenceObjClass.where(
      "buildingType",
      "contains",
      buildingTypes
    ).toArray()
  )
}
